import { c as _c } from "react/compiler-runtime";
import { useCallback, useEffect, useState } from 'react';
import useSWR from 'swr';
import { getPreferredStopDirection, getStopDeparturesKey, updatePreferredStopDirection, resolveStopDirectionControl } from './stopDepartureBoard.js';

// Regions provide either stop metadata or a response-owned direction control.
// Preferences, request identity, evidence restoration and polling live here.
export function useStopDepartureBoard(t0) {
  const $ = _c(44);
  const {
    stopId,
    ready,
    isArrivalOnly,
    date: t1,
    directionControl,
    preferredDirections,
    setPreferredDirections,
    services,
    destination,
    recent,
    vehicles,
    fetcher,
    onLiveUpdate
  } = t0;
  const date = t1 === undefined ? null : t1;
  let preferredDirection;
  let t2;
  if ($[0] !== date || $[1] !== destination || $[2] !== directionControl || $[3] !== isArrivalOnly || $[4] !== preferredDirections || $[5] !== ready || $[6] !== recent || $[7] !== services || $[8] !== stopId || $[9] !== vehicles) {
    preferredDirection = getPreferredStopDirection(preferredDirections, stopId);
    t2 = getStopDeparturesKey({
      stopId,
      ready,
      isArrivalOnly,
      date,
      directionControl,
      preferredDirection,
      services,
      destination,
      recent,
      vehicles
    });
    $[0] = date;
    $[1] = destination;
    $[2] = directionControl;
    $[3] = isArrivalOnly;
    $[4] = preferredDirections;
    $[5] = ready;
    $[6] = recent;
    $[7] = services;
    $[8] = stopId;
    $[9] = vehicles;
    $[10] = preferredDirection;
    $[11] = t2;
  } else {
    preferredDirection = $[10];
    t2 = $[11];
  }
  const departuresKey = t2;
  const t3 = date ? 0 : 20000;
  const t4 = !date;
  const t5 = date ? 60000 : 10000;
  let t6;
  if ($[12] !== date || $[13] !== onLiveUpdate) {
    t6 = () => {
      if (!date) {
        onLiveUpdate?.(Date.now());
      }
    };
    $[12] = date;
    $[13] = onLiveUpdate;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t3 || $[16] !== t4 || $[17] !== t5 || $[18] !== t6) {
    t7 = {
      keepPreviousData: false,
      refreshInterval: t3,
      revalidateOnFocus: t4,
      refreshWhenHidden: false,
      refreshWhenOffline: false,
      dedupingInterval: t5,
      onSuccess: t6
    };
    $[15] = t3;
    $[16] = t4;
    $[17] = t5;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  const {
    data: response,
    isLoading,
    isValidating,
    error
  } = useSWR(departuresKey, fetcher, t7);
  const scope = `${stopId}:${date || "live"}`;
  const [evidence, setEvidence] = useState(null);
  let t8;
  let t9;
  if ($[20] !== error || $[21] !== response || $[22] !== scope) {
    t8 = () => {
      if (error) {
        setEvidence(null);
      } else {
        if (response !== undefined) {
          setEvidence({
            scope,
            control: response?.direction_control ?? null
          });
        }
      }
    };
    t9 = [response, scope, error];
    $[20] = error;
    $[21] = response;
    $[22] = scope;
    $[23] = t8;
    $[24] = t9;
  } else {
    t8 = $[23];
    t9 = $[24];
  }
  useEffect(t8, t9);
  let t10;
  if ($[25] !== directionControl || $[26] !== error || $[27] !== evidence || $[28] !== response || $[29] !== scope) {
    t10 = resolveStopDirectionControl({
      directionControl,
      response,
      error,
      evidence,
      scope
    });
    $[25] = directionControl;
    $[26] = error;
    $[27] = evidence;
    $[28] = response;
    $[29] = scope;
    $[30] = t10;
  } else {
    t10 = $[30];
  }
  const control = t10;
  const supportsDirectionPicker = Boolean(departuresKey && control?.enabled && (directionControl !== null || control.labels?.inbound && control.labels?.outbound));
  let t11;
  if ($[31] !== setPreferredDirections || $[32] !== stopId) {
    t11 = value => {
      setPreferredDirections(previous => updatePreferredStopDirection(previous, stopId, value));
    };
    $[31] = setPreferredDirections;
    $[32] = stopId;
    $[33] = t11;
  } else {
    t11 = $[33];
  }
  const setDirection = t11;
  const t12 = departuresKey ? response?.departures ?? response : undefined;
  const t13 = control?.labels;
  const t14 = supportsDirectionPicker ? preferredDirection : null;
  let t15;
  if ($[34] !== departuresKey || $[35] !== error || $[36] !== isLoading || $[37] !== isValidating || $[38] !== setDirection || $[39] !== supportsDirectionPicker || $[40] !== t12 || $[41] !== t13 || $[42] !== t14) {
    t15 = {
      departuresKey,
      rawDepartures: t12,
      isLoading,
      isValidating,
      error,
      supportsDirectionPicker,
      stationDirectionLabels: t13,
      direction: t14,
      setDirection
    };
    $[34] = departuresKey;
    $[35] = error;
    $[36] = isLoading;
    $[37] = isValidating;
    $[38] = setDirection;
    $[39] = supportsDirectionPicker;
    $[40] = t12;
    $[41] = t13;
    $[42] = t14;
    $[43] = t15;
  } else {
    t15 = $[43];
  }
  return t15;
}